/*
 *
 * AddShelf
 *
 */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  removeCabinetAction,
  setImageAction,
  updateCabinetSuccess,
} from 'containers/Configurator/actions/furniture';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'containers/Ribbon/CabinetRibbon/types';
import {
  makeSelectCabinet,
  makeSelectFurniture,
  makeSelectSelectedIdCabinet,
} from 'containers/Configurator/selectors/furniture';
import { useTranslation } from 'react-i18next';
import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import addCabinetImg from 'assets/images/ribbons/cabinetRibbon/addCabinet.svg';
import addCabinetSmallImg from 'assets/images/ribbons/cabinetRibbon/addCabinetSmall.svg';
import Button from 'components/Button';
import { Furniture } from 'lib/modelBuilder/entities/Furniture';
import { getPNGimage } from 'containers/Viewer';
import { FiTrash } from 'react-icons/fi';

interface StateProps {
  cabinet: Cabinet | null;
  furniture: Furniture | null;
  selectedIdCabinet: string | null;
}

const mapStateToProps = createStructuredSelector<RootState, StateProps>({
  cabinet: makeSelectCabinet(),
  furniture: makeSelectFurniture(),
  selectedIdCabinet: makeSelectSelectedIdCabinet(),
});

function FurnitureSection() {
  const dispatch = useDispatch();
  const { cabinet, furniture, selectedIdCabinet } = useSelector(
    mapStateToProps,
  );
  const { t } = useTranslation();

  function removeCabinet() {
    if (selectedIdCabinet !== null)
      dispatch(removeCabinetAction(selectedIdCabinet));
  }

  function addCabinet() {
    /**
     * Add a cabinet to the furniture
     * If we don't have a specific (selected) cabinet to add, we clone the last one
     */

    if (cabinet) {
      if (!furniture) throw new Error('Furniture must exist');
      cabinet.thumbnail = getPNGimage(100, 100);
      const image = getPNGimage();
      const newCabinet = cabinet.makeCopy();
      const newFurniture = furniture.clone().add(newCabinet);
      dispatch(updateCabinetSuccess(newFurniture, null));
      dispatch(setImageAction(image, cabinet.id));
      dispatch(setImageAction(image, newCabinet.id));
    } else if (selectedIdCabinet === null && furniture && furniture.last) {
      dispatch(
        updateCabinetSuccess(
          furniture.clone().add(furniture.last.makeCopy()),
          null,
        ),
      );
    }
  }

  let multi = null;
  if (furniture && furniture.quantity > 1 && selectedIdCabinet !== null) {
    multi = (
      <div className="mt-3 ml-3">
        <button onClick={removeCabinet} className="flex items-center">
          <FiTrash className="text-red-dark h-6 w-6" />
          <div className="text-sm ml-2">{t('Remove this cabinet')}</div>
        </button>
      </div>
    );
  }

  return (
    <div className={`${multi && '-mt-5'}`}>
      {multi}
      <Button
        title={t('Add a furniture unit')}
        onClick={addCabinet}
        img={multi !== null ? addCabinetSmallImg : addCabinetImg}
        small={multi !== null}
      />
    </div>
  );
}

export default FurnitureSection;
